module.exports = __webpack_public_path__ + "img/full2-min.37c68d2b.png";